// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContributionSegmentDto
 */
export interface IContributionSegmentDto {
    /**
     * 
     * @type {Array<number>}
     * @memberof IContributionSegmentDto
     */
    segment_subsidiary_ids?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContributionSegmentDto
     */
    segment_plan_codes?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof IContributionSegmentDto
     */
    segment_employee_ids?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContributionSegmentDto
     */
    segment_payroll_group_codes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentDto
     */
    tax_type?: IContributionSegmentDtoTaxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentDto
     */
    tax_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentDto
     */
    contribution_segment_type?: IContributionSegmentDtoContributionSegmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentDto
     */
    memo?: string;
}

/**
* @export
* @enum {string}
*/
export enum IContributionSegmentDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}
/**
* @export
* @enum {string}
*/
export enum IContributionSegmentDtoContributionSegmentTypeEnum {
    SINGLE = 'SINGLE',
    ALL_EMPLOYEES = 'ALL_EMPLOYEES',
    PLANS = 'PLANS',
    SUBSIDIARY = 'SUBSIDIARY',
    PAYROLL_GROUP = 'PAYROLL_GROUP'
}


/**
 * Check if a given object implements the IContributionSegmentDto interface.
 */
export function instanceOfIContributionSegmentDto(value: object): value is IContributionSegmentDto {
    return true;
}

export function IContributionSegmentDtoFromJSON(json: any): IContributionSegmentDto {
    return IContributionSegmentDtoFromJSONTyped(json, false);
}

export function IContributionSegmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionSegmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'segment_subsidiary_ids': json['segment_subsidiary_ids'] == null ? undefined : json['segment_subsidiary_ids'],
        'segment_plan_codes': json['segment_plan_codes'] == null ? undefined : json['segment_plan_codes'],
        'segment_employee_ids': json['segment_employee_ids'] == null ? undefined : json['segment_employee_ids'],
        'segment_payroll_group_codes': json['segment_payroll_group_codes'] == null ? undefined : json['segment_payroll_group_codes'],
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'contribution_segment_type': json['contribution_segment_type'] == null ? undefined : json['contribution_segment_type'],
        'memo': json['memo'] == null ? undefined : json['memo'],
    };
}

export function IContributionSegmentDtoToJSON(json: any): IContributionSegmentDto {
    return IContributionSegmentDtoToJSONTyped(json, false);
}

export function IContributionSegmentDtoToJSONTyped(value?: IContributionSegmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'segment_subsidiary_ids': value['segment_subsidiary_ids'],
        'segment_plan_codes': value['segment_plan_codes'],
        'segment_employee_ids': value['segment_employee_ids'],
        'segment_payroll_group_codes': value['segment_payroll_group_codes'],
        'tax_type': value['tax_type'],
        'tax_year': value['tax_year'],
        'contribution_segment_type': value['contribution_segment_type'],
        'memo': value['memo'],
    };
}

